const { registerBlockType } = wp.blocks;
const { RichText, MediaUpload, MediaUploadCheck, InspectorControls } =
  wp.blockEditor;
const { Button, PanelBody, SelectControl } = wp.components;
const { Fragment } = wp.element;
const { __ } = wp.i18n;

registerBlockType('pg/hero-bottom-image', {
  title: __('PG Hero Bottom Image'),
  icon: 'format-image',
  category: 'layout',
  attributes: {
    eyebrow: { type: 'string', default: '' },
    heading: { type: 'string', default: '' },
    description: { type: 'string', default: '' },
    imgSrc: {
      type: 'string',
      default: '',
    },
    imgAlt: { type: 'string', default: '' }, // Added imgAlt attribute
    sectionClass: { type: 'string', default: 'section-light-primary' },
  },
  edit: ({ attributes, setAttributes }) => {
    const { eyebrow, heading, description, imgSrc, imgAlt, sectionClass } =
      attributes;

    const onSelectImage = (media) => {
      setAttributes({
        imgSrc: media.url,
        imgAlt: media.alt || '', // Capture the alt text
      });
    };

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    return (
      <Fragment>
        <InspectorControls>
          <PanelBody title={__('Settings')}>
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
          </PanelBody>
        </InspectorControls>
        <section className={sectionClass}>
          <div className="corner corner-light-primary corner-on-light-secondary corner-right-bottom"></div>
          <div className="leadership-top-section">
            <RichText
              tagName="p"
              className="h1-eyebrow"
              value={eyebrow}
              onChange={(value) => setAttributes({ eyebrow: value })}
              placeholder={__('Eyebrow')}
            />
            <RichText
              tagName="h1"
              value={heading}
              onChange={(value) => setAttributes({ heading: value })}
              placeholder={__('Heading')}
            />
            <RichText
              tagName="p"
              className="description"
              value={description}
              onChange={(value) => setAttributes({ description: value })}
              placeholder={__('Description')}
            />
            <div className="leaders">
              <MediaUploadCheck>
                <MediaUpload
                  onSelect={onSelectImage}
                  allowedTypes={['image']}
                  value={imgSrc}
                  render={({ open }) => (
                    <Button onClick={open} isPrimary>
                      {__('Upload Image')}
                    </Button>
                  )}
                />
              </MediaUploadCheck>
              {imgSrc && <img src={imgSrc} alt={imgAlt} />}
            </div>
          </div>
        </section>
      </Fragment>
    );
  },
  save: ({ attributes }) => {
    const { eyebrow, heading, description, imgSrc, imgAlt, sectionClass } =
      attributes;

    return (
      <section className={sectionClass}>
        <div className="corner corner-light-primary corner-on-light-secondary corner-right-bottom"></div>
        <div className="leadership-top-section">
          <RichText.Content
            tagName="p"
            className="h1-eyebrow"
            value={eyebrow}
          />
          <RichText.Content tagName="h1" value={heading} />
          <RichText.Content
            tagName="p"
            className="description"
            value={description}
          />
          <div className="leaders">
            {imgSrc && <img src={imgSrc} alt={imgAlt || ''} />}
          </div>{' '}
          {/* Use imgAlt */}
        </div>
      </section>
    );
  },
});
